
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32pt","height":"32pt","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5 4v8h18V4zm2 2h14v4H7zm17 1v2h1v4.25l-9.281 2.781-.719.219V19h-2v9h6v-9h-2v-1.25l9.281-2.781.719-.219V7zm-9 14h2v5h-2z"}})])
          )
        }
      }
    